/*
Emit On Dirty

Emits jquery events when decorated the value of the decorated element changes.

### Html Attributes

```
  data-add-element-classes
  data-add-element-classes--event-name-dirty="valid jquery event name"
  data-add-element-classes--event-name-clean="valid jquery event name"
```

Markup:
<div id="EmitOnDirtyIndicator" class="styleguide-box" style="width: 5rem;height: 5rem;"></div>
<div class="u-align u-align--vertical">
  <div>
    Toggles the class `JS--is-dirty` when field is clean or dirty.
    changes box to red
    <input type="text"
           name="q"
           value="Initial value"
           placeholder="Change me"
           data-emit-on-dirty
           data-add-element-classes
           data-add-element-classes--on="EmitOnDirty.dirty"
           data-add-element-classes--target="#EmitOnDirtyIndicator"
           data-add-element-classes--classes="styleguide-box--red"
           data-remove-element-classes
           data-remove-element-classes--on="EmitOnDirty.clean"
           data-remove-element-classes--target="#EmitOnDirtyIndicator"
           data-remove-element-classes--classes="styleguide-box--red">
  </div>
  <div>
    Customise the clean/dirty event names emitted.
    changes box to skyblue
    <input type="text"
           name="q"
           value="Initial value"
           placeholder="Change me"
           data-emit-on-dirty
           data-emit-on-dirty--event-name-dirty="field-dirty"
           data-emit-on-dirty--event-name-clean="field-clean"
           data-add-element-classes
           data-add-element-classes--on="field-clean"
           data-add-element-classes--target="#EmitOnDirtyIndicator"
           data-add-element-classes--classes="styleguide-box--red"
           data-remove-element-classes
           data-remove-element-classes--on="field-dirty"
           data-remove-element-classes--target="#EmitOnDirtyIndicator"
           data-remove-element-classes--classes="styleguide-box--red">
  </div>
</div>


Styleguide Global.Javascript.EmitWhenDirty
*/
import $ from 'jquery';

/* global $:true */
import debug from 'debug';
import plugin from '@core/plugins/lib';
import { ELEMENT_SELECTOR, PLUGIN_NAME } from './index';

const MODULE_NAME = 'global/emit-on-dirty';
const log = debug(MODULE_NAME);


log('registerd');

class EmitOnDirty {

  constructor(element, options) {
    log('new instance', element, options);

    this.element = element;
    this.options = options;

    this.$element = $(element);
    this.initial = this.value;

    this.$element.on(this.options.on, this.change.bind(this));

    log('ready', this.$element);

    this.change();
  }

  change() {
    const options = this.options;
    const value = this.value;
    const initial = this.initial;
    log('change', this.$element, value, initial);

    if (this.isDirty) {
      this.$element.trigger(this.options.eventNameDirty, { options, value, initial});
    } else {
      this.$element.trigger(this.options.eventNameClean, { options, value, initial});
    }
  }

  clean () {
    this.initial = this.$element.val();
    this.change();
  }

  get value () {
    return this.$element.val();
    // const elementTag = this.$element.prop('tagName');

    // switch (this.options.valueAttribute) {
    //   case "value":
    //     return elementTag === 'INPUT' && this.$element.val()
    //       || this.$element.attr('value');
    //   default:
    //     return this.$element.attr(this.options.valueAttribute);
    // }
  }

  get isDirty() {
    const yesno = this.initial !== this.value;
    log('isDirty', this.$element, yesno);

    return yesno;
  }

}

EmitOnDirty.DEFAULTS = {
  on: 'keyup change',
  valueAttribute: 'value',
  eventNameDirty: `${PLUGIN_NAME}.dirty`,
  eventNameClean: `${PLUGIN_NAME}.clean`
};

export default EmitOnDirty;
//plugin(PLUGIN_NAME, EmitOnDirty);



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__emit-on-dirty/plugin.js